<ng-container *ngIf="!contratoStatus">
  <div class="onboarding-contrato__container">
    <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
    <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
    <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
    <app-onboarding-card-placeholder></app-onboarding-card-placeholder>
  </div>
</ng-container>

<div class="onboarding-contrato__container" *ngIf="contratoStatus">
  <app-onboarding-card
    imageUrl="../../../../../assets/images/contract.png"
    title="Contratos"
    redirectTo="/contratos"
    [checked]="contratoStatus.contrato"
    [disabled]="false"
  ></app-onboarding-card>

  <app-onboarding-card
    imageUrl="../../../../../assets/images/project-management.png"
    title="Graus de Parentesco Permitidos"
    redirectTo="/contratos"
    [checked]="contratoStatus.contratoGrauDeParentesco"
    [disabled]="!contratoStatus.contrato"
  ></app-onboarding-card>

  <app-onboarding-card
    imageUrl="../../../../../assets/images/decentralized.png"
    title="Tabela de Preço do Produto"
    redirectTo="/contratos"
    [checked]="contratoStatus.contratoProdutoTabelaDePreco"
    [disabled]="!contratoStatus.contratoGrauDeParentesco"
  ></app-onboarding-card>

  <app-onboarding-card
    imageUrl="../../../../../assets/images/listing.png"
    title="Elegibilidade do Produto"
    redirectTo="/contratos"
    [checked]="contratoStatus.contratoProdutoEstruturaOrganizacional"
    [disabled]="!contratoStatus.contratoProdutoTabelaDePreco"
  ></app-onboarding-card>
</div>

<form class="d-flex justify-content-end">
  <button
    mat-flat-button
    color="primary"
    type="submit"
    (click)="next.emit()"
    [disabled]="!contratoStatus?.contratoProdutoTabelaDePreco"
  >
    Próximo
  </button>
</form>
